import { compose, identity, path, merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';

export default class CreateConsultantForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    return (
      <form>
        {this.renderInput('Nombre', 'name')}
        {this.renderInput('Email', 'username')}
        {this.renderNumberInput('Licencias', 'totallicenses')}
      </form>
    );
  }
  renderInput(label, id) {
    const input = <input type='text' value={this.props.value[id]} onChange={this.handleChange(id, path(['target', 'value']))} />;
    return this.renderRow(label, input);
  }
  renderNumberInput(label, id) {
    const input = <NumberInput value={this.props.value.totallicenses} onChange={this.handleChange('totallicenses', identity)} min="0" max="100" />;
    return this.renderRow(label, input);
  }
  renderRow(label, input) {
    return (
      <div className='row form-group'>
        <label className='col-xs-3 col-xs-offset-2' style={{ textAlign: 'right' }}>{label}</label>
        <div className='col-xs-6'>
          {input}
        </div>
      </div>
    );
  }
  handleChange(field, getValue) {
    return (event) => {
      const value = getValue(event);
      this.props.onChange(merge(this.props.value, { [field]: value }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/consultants/CreateConsultantForm.jsx